export default {
  'YouTube and High Definition Videos': 'YouTube and High Definition Videos',
  'Story videos (Instagram/Snaps/TikTok)': 'Story videos (Instagram/Snaps/TikTok)',
  'Facebook and Instagram Feed videos': 'Facebook and Instagram Feed videos',
  'Facebook and Twitter Portrait Videos': 'Facebook and Twitter Portrait Videos',
  'Twitter and Facebbok Landscape Videos': 'Twitter and Facebbok Landscape Videos',
  'Facebook Cover Videos And Blog Banners': 'Facebook Cover Videos And Blog Banners',
  'Fit': 'Fit',
  'Fill': 'Fill',
}